import JourFerieFormController from './jour.ferie.form.controller';

export default {
    template: require('./jour.ferie.form.html'),
    controller: JourFerieFormController
};
